var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.93756 2.5C9.76497 2.5 9.62506 2.63991 9.62506 2.8125V9.12498H3.3125C3.13991 9.12498 3 9.2649 3 9.43748V10.5625C3 10.7351 3.13991 10.875 3.3125 10.875H9.62506V17.1875C9.62506 17.3601 9.76497 17.5 9.93756 17.5H11.0626C11.2352 17.5 11.3751 17.3601 11.3751 17.1875V10.875H17.6875C17.8601 10.875 18 10.7351 18 10.5625V9.43748C18 9.2649 17.8601 9.12498 17.6875 9.12498H11.3751V2.8125C11.3751 2.63991 11.2352 2.5 11.0626 2.5H9.93756Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.d61ea5e10707fded97363059e2a15381.svg";
export { ForwardRef as ReactComponent };